import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { translations } from '@/data/translations';

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    if (typeof window === 'undefined') return 'es';
    return localStorage.getItem('jelly_lang') || 'es';
  });

  useEffect(() => {
    localStorage.setItem('jelly_lang', lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = useCallback((path) => {
    const keys = path.split('.');
    let cur = translations[lang];
    for (const k of keys) {
      if (cur == null) return path;
      cur = cur[k];
    }
    return cur ?? path;
  }, [lang]);

  const toggle = useCallback(() => setLang((l) => (l === 'es' ? 'en' : 'es')), []);

  const value = useMemo(() => ({ lang, setLang, toggle, t }), [lang, toggle, t]);

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLang must be used inside LanguageProvider');
  return ctx;
};
